var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-motto"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('activerecord.attributes.company.motto')))]), _vm._v(" "), _c('autosize-textarea', {
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-motto",
      "type": "text",
      "rows": "1",
      "maxlength": "85"
    },
    model: {
      value: (_vm.company.motto),
      callback: function($$v) {
        _vm.company.motto = $$v
      },
      expression: "company.motto"
    }
  })], 1), _vm._v(" "), (_vm.company.motto) ? _c('p', {
    staticClass: "motto"
  }, [_vm._v(_vm._s(_vm.company.motto))]) : _c('p', {
    staticClass: "motto motto--empty"
  }, [_vm._v(_vm._s(_vm.I18n.t('add_a_company_motto')))])], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d6d00c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/motto.vue
// module id = null
// module chunks = 